import api, { resetRetry } from '../Api'

export default async function login ( { username, passwd } ) {

    resetRetry()

    return api.post( '/api/v1/token/', { username: username, password: passwd } )

}
